const styles = () => ({
  subHeader: {
    top: -5,
    position: 'relative',
    fontSize: '0.8em'
  }
});

export default styles;